import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { Location } from '@angular/common';
import { MatButton } from '@angular/material/button';

declare var $: any;
@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

	public asgAdminUrl = environment.asgAdminUrl;
	public asgSecurityUrl = environment.asgSecurityUrl;
	private readonly notifier: NotifierService;
	errorMessage = '';
	hide = true;
	showForm = true;
	showMsg = false;
	public showHelpIcon = false;
	userType = '';
	
	constructor(
		private router: Router,
		private login: LoginService	) {
		if (localStorage.getItem('ssoData') && JSON.parse(localStorage.getItem('ssoData')).sso_enabled === "true")
			this.userType = JSON.parse(localStorage.getItem('ssoData')).sso_type ? 'Sso' : null;
		if (!this.userType){
      this.userType = localStorage.getItem('userType');
    }			
	}

	ngOnInit() {
	
}

	
	hasClass() {
		if (document.getElementById("myLauncher").classList.contains('help-icon')) {
			this.showHelpIcon = false
		} else if (document.getElementById("myLauncher").classList.contains('help-icon-click')) {
			this.showHelpIcon = true;
		}
		return this.showHelpIcon;
	}

	ShowHelp() {
		if (!this.showHelpIcon) {
			this.showHelpIcon = true;
			this.login.setZendeskView(false);
		}
	}

	goToSSOPage() {
		localStorage.clear();
		this.router.navigate(['/login'])
	}
}
